import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=5b999869&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=5b999869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b999869",
  null
  
)

export default component.exports